import React, {Component, Fragment} from 'react';
import {get, post,postResponse} from "../../../server/actions";
import {URL_VERSION, MONTH, MealTypes,MenuOrderTypes} from '../../../server/constants';
import $ from 'jquery'
import {BeatLoader} from 'react-spinners';
import NumberBox from '../../Misc/NumericBox';
import '../../../assets/css/MonthPicker.min.css'
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import {_addNotificationError,getAccessLevelByModule,getModuleEnum, getSchoolGrades, groupBy,
    buildGradeName,getMonthNameByNumber, gradeNoToText, isRegularLunchOrderType, allowNumericWithdecimal} from "../../../server/util";
import moment from  'moment';

let converter = require('number-to-words');

let meals = [];
let date = {};
let mealSchoolId = '';
const modEnum=getModuleEnum();
let gradeList=[];
class mealForm extends Component {
    componentDidMount = () => {
        this.initDatepicker();
        this._notificationSystem = this.refs.notificationSystem;
    }
    initDatepicker = () => {
    }
    componentWillMount = () => {
        mealSchoolId = sessionStorage.getItem('SchoolId');
        this.getMealExcel();
    }
    refreshForm=()=>{
        this.getMealExcel();
       /*  if(this.ref.calendar){
            this.refs.calendar.closeCalendar()
        } */
    }
    getMealExcel = () => {
        let mealMonths = [];
        for (let i = 0; i < 6; i++) {
            let d = new Date();
            d.setMonth(d.getMonth() + (2 - i));
            mealMonths.push("" + d.getFullYear() + (('0' + (d.getMonth())).slice(-2)))
        }
        this.setState({show: !this.state.show}, () => {
            //if (this.state.show) {
                this.setState({loading: true});
                //const mType=(this.props.type===MealTypes.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.props.type;
                get('/mealsExcelSummaries/search/mealExcelList?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&itemType='+this.props.type+'&size=10&access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
                    document.getElementById("file").innerHTML='';

                    if (data._embedded.mealsExcelSummaries.length > 0) {
                        const gradeGroup=groupBy(getSchoolGrades(0,false),'value');
                        data._embedded.mealsExcelSummaries.map((file) => {
                            let m = file.yearMonth.slice(-2);
                            let y = file.yearMonth.substring(0, 4)
                            try {
                                let x = (file.grades||[]).map(gVal=>{
                                    return ((gradeGroup[gVal]||[])[0]||{}).label||gVal;
                                })  //buildGradeName(file.grades);
                                file.month = MONTH[m - 1] + " " + y + " , Grades: " + x;
                            }
                            catch (e) {
                                file.month = MONTH[m - 1] + " " + y + " , Grades: " + file.grades.map(grade => {
                                    return ((gradeGroup[grade]||[])[0]||{}).label||grade;
                                });
                            }
                            document.getElementById("file").innerHTML += '<div class="clearfix excel-file-div" style="background-color: #f5f5f5;box-shadow: 0 0 1px grey;"><a title="'+file.month+'" href="'+file.excelLink+'" class="col-md-12 col-sm-12 col-xs-12 excel-file-link-text"><i class="fa fa-file-excel-o tbl-rounded-icon bg-color-2 fa-icon"></i><label class="">' + file.month + '</label></a></div>'
                            this.setState({loading: false, show: true});
                        })
                    } else {
                        this.setState({loading: false, show: true});
                        document.getElementById("file").innerHTML = '<p>No Records Found</p>';
                    }
                }).catch(
                    (error) => {
                        this.setState({loading: false});
                        console.log('Cannot load meals', error)
                        this.setState({loading: false, show: true});
                    }
                );
            //} else {
            //    document.getElementById("file").innerHTML = '';
           // }
        });
    }
    selectDate = (e) => {
        let d = new Date(e);
        date.year = d.getFullYear();
        date.month = d.getMonth() + 1;
        this.refs.calendar.closeCalendar()
        document.getElementById("select_all").checked=false;
		 this.props.onMealDateSelectionChange(date.year+''+(('0' +(date.month)).slice(-2)));
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    checkAllGrades = (event) => {        
        this.props.onChangeGradeSelection(event.target.value,event.target.checked);

        var checkboxes = document.getElementsByName("grades");
        let j = 0;
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                j++
            }
        }
        var select_all = document.getElementById("select_all");
        if (j === checkboxes.length) {
            select_all.checked = true;
        } else {
            select_all.checked = false;
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false,
            allow:false,
            hasError:false,
            discount:{
                isDiscountApplyed: this.props.mealObject.isDiscountApplyed,
                itemPriceDisForMonthlyOrder:((this.props.mealObject||{}).itemPriceDisForMonthlyOrder||0)
            }
        }
        this.allGrades = this.allGrades.bind(this);
    }

    allGrades() {
        var select_all = document.getElementById("select_all");
        this.props.onChangeGradeSelection('select_all',select_all.checked);
        //$('input[name="grades"]').prop('checked',this.checked);
        var checkboxes = document.getElementsByName("grades");
        for (let i = 0; i < checkboxes.length; i++) {
            if(!checkboxes[i].disabled)
            checkboxes[i].checked = select_all.checked;
        }
    }
    handleSubmit(e) {
        const {mealObject}=this.props
        e.preventDefault();
        let loginUser=sessionStorage.getItem('loggedUserName');
        let selectedCount=0;
       for (let i = 0; i < $("input[type=checkbox]:checked").not( "#select_all" ).length; i++) {
            if(!$("input[type=checkbox]:checked").not( "#select_all" )[i].disabled)
            selectedCount++;
        }
        if (selectedCount=== 0) {
            _addNotificationError("Select atleast one grade to create the menu.", this)
            return false;
        }       
        let selectedGrades = $('input[name="grades"]:checked').map(function () {
            if(this.disabled==false)
                return this.value;
        }).get();
        let grades = [];
        selectedGrades.map(grade => {
            //grades.push(gradeNoToText(grade));
            grades.push(grade);
        })
        if((grades||[]).length===0){
            _addNotificationError("Select atleast one grade to create the menu.", this)
            this.setState({loading: false})
            return false;
        }
        if(mealObject.isCatererMenu)
        {
            const url=`/mealSummaryDetails?menuSummaryId=${mealObject._links.self.href.split('/').pop()}&isViewMenu=true&access_token=`;
            get(url).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                const resp={mealMenuItems:(data.menuItemsList||[]).sort((a, b) => (a.title||a.name).localeCompare((b.title||b.name))).map(itm=>{
                    return {...itm, title:(itm.name||itm.title), start: new Date(moment(itm.start,'YYYY-MM-DD').toDate())}
                })}
                if (resp.mealMenuItems.length>0) {
                    if(this.props.isEdit){                    
                        date.year=mealObject.yearMonth.substring(0,4);
                        date.month=mealObject.yearMonth.slice(-2);
                    }
                    this.props.loadMeals(resp, selectedGrades, date, data);
                }

            }).catch(
                    (error) => {
                        console.log('Get orderlist response', error)
                        this.setState({ loading: false})
                    }
                )

        }else
        {
            if(this.props.isEdit && ((document.getElementById('mealFile')||{}).value||[]).length<=0){
                const url=`/mealSummaryDetails?menuSummaryId=${mealObject._links.self.href.split('/').pop()}&isViewMenu=true&access_token=`;
                get(url).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    const resp={mealMenuItems:(data.menuItemsList||[]).sort((a, b) => a.title.localeCompare(b.title)).map(itm=>{
                        return {...itm, title:itm.name, start: new Date(moment(itm.start,'YYYY-MM-DD').toDate())}
                    })}
                    if (resp.mealMenuItems.length>0) {
                        if(this.props.isEdit){                    
                            date.year=mealObject.yearMonth.substring(0,4);
                            date.month=mealObject.yearMonth.slice(-2);
                        }
                        this.props.loadMeals(resp, selectedGrades, date, data);
                    }
    
                }).catch(
                        (error) => {
                            console.log('Get orderlist response', error)
                            this.setState({ loading: false})
                        }
                    )

            }else{
                    if(((document.getElementById('mealFile')||{}).value||[]).length<=0){
                        return false;
                    }
                    let fileInput = document.getElementById('mealFile').files[0];
                    var data = new FormData();
                    data.append('file', fileInput);
                    let yearMonth
                    if(this.props.isEdit==true){
                        yearMonth=this.props.mealObject.yearMonth
            
                    }else{
                    yearMonth = "" + date.year + (('0' + (date.month)).slice(-2));
                    }
                    if(this.props.isEdit){
                        data.append('mealSummaryId', this.props.mealObject.mealSummaryId);
                    }
                    this.setState({loading: true})
                    //const mType=(this.props.type===MealTypes.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.props.type;
                    postResponse(URL_VERSION+'/menuJson?menuType='+this.props.type+'&mealSchoolId=' + sessionStorage.getItem("SchoolId") +'&isExtraPreOrder=' + this.state.allow + '&gradeNames=' + (grades||[]) + '&yearMonth=' + yearMonth + '&loggedUser='+loginUser + '&access_token=', data).then((response) => {
                        localStorage.setItem('isExtraPreOrder',this.state.allow);
                        if (response.statusCode!=200) {
                            /* if (response.status === 417) {
                                _addNotificationError("Meal Menu Already created", this)
                            } else if (response.status === 409 || response.status === 422 || response.status === 500) {
                                _addNotificationError("Import failed. Please check your data and try again", this)
                            } else {
                                _addNotificationError("Import failed. Please try again later", this)
                            } */
                            throw Error(response.statusMessage);
                        }
                        return response;
                    }).then(data => {
                        console.log(data)
                        meals = eval('(' + data.mealJsonData + ')');
                        if (meals !== null) {
                            if(this.props.isEdit){                    
                                date.year=this.props.mealObject.yearMonth.substring(0,4);
                                date.month=this.props.mealObject.yearMonth.slice(-2);
                            }
                            this.props.loadMeals(meals, selectedGrades, date);
                        }
                    }).catch(
                        (error) => {
                            this.setState({loading: false})
                            _addNotificationError(error.message, this)
                            console.log('Cannot load meals', error)
                        }
                    );
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        const _discount=this.state.discount;
        _discount.isDiscountApplyed= nextProps.mealObject.isDiscountApplyed||false;
        _discount.itemPriceDisForMonthlyOrder=nextProps.mealObject.itemPriceDisForMonthlyOrder||0;
       this.setState({discount:_discount})
    }
    

    render() {
        let min_month = date.year + '-' + (('0' + date.month).slice(-2));
        gradeList=getSchoolGrades(0,false);
        const {mealObject}=this.props
        return (
            <section className="mainContent full-width clearfix">
                <NotificationSystem ref="notificationSystem"/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="row">
                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="col-md-8 col-sm-12 col-xs-12 text-center createmenu-panel">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title"> {this.props.title}</h3>
                                </div>
                                <div className="panel-body">
                                
                                {this.props.isEdit?
                                (<div className="uploadFileInfo col-md-12 createmenu-month-group">
                                <label className="custom-label col-md-3 text-left">Selected Month</label>
                                <div className="input-group col-md-7 col-sm-12 col-xs-12" style={{backgroundColor: "#f5f5f5",boxShadow: '0 0 1px grey'}} >

                                   <label>{getMonthNameByNumber((this.props.mealObject.yearMonth||'').slice(-2))+' '+(this.props.mealObject.yearMonth||'').substring(0,4)}</label>
                                </div>
                            </div>)

                                :
                                    (<div className="uploadFileInfo col-md-12 createmenu-month-group">
                                        <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}>Select Month</label>
                                        <div className="input-group col-md-7 col-sm-12 col-xs-12">

                                            <Datetime ref='calendar' dateFormat="MMMM YYYY" timeFormat={false}
                                                      closeOnSelect={true}
                                                      isValidDate={(currentDate)=>{
                                                let minDate=moment();
                                                minDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                currentDate.set({hour:0,minute:0,second:0,millisecond:0})
                                                return (minDate<=currentDate) ;
                                            }}
                                                      onChange={this.selectDate.bind(this)} renderInput={this.renderInput}/>
                                        </div>
                                    </div>)
                                }
                                
                                <div className="col-md-12" style={{marginTop:'7px'}}>
                                    <label className="custom-label col-md-3 text-left">Name</label>
                                    <div className="input-group col-md-7 col-sm-12 col-xs-12" >

                                    <input type="text" name="name" className='form-control' value={this.props.mealObject.name} onChange={(e)=>{
                                        this.props.onChangeMenuTitle(e);
                                    }} />
                                    </div>
                                </div>
                                    <div className="col-md-12 createmenu-grade-group" style={{display:(this.props.schoolGrades.length>0?'block':'none') }}>
                                        <label className="custom-label col-md-3 text-left" style={{margin: '18px 0px'}}>Select Grades</label>
                                        <div className="col-md-7 input-group">
                                            <div class="styled-input-container styled-input--square">
                                                <div className="styled-input-single col-sm-12">
                                                    <input type="checkbox" name="fieldset-6" id="select_all"                                                    
                                                    disabled={this.props.schoolGrades.every((grade)=>{
                                                        return grade.enabled===false
                                                    })}
                                                    onChange={this.allGrades}/>
                                                    <label htmlFor="select_all">All</label>
                                                </div>
                                                {
                                                    this.props.schoolGrades.map(grade => {
                                                        return (
                                                            <div className="styled-input-single col-md-2 pull-left"
                                                                 style={{margin: '-15px 8px'}}>
                                                                <input type="checkbox" name="grades"
                                                                       onChange={this.checkAllGrades}
                                                                       id={grade.name} value={grade.value} 
                                                                       checked={grade.checked?true:false}
                                                                       disabled={grade.enabled?false:true}
                                                                       />
                                                                <label className={ !grade.enabled? 'disable-checkbox':''}  for={grade.name}>{grade.name}</label>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        mealObject.isCatererMenu?
                                        <div></div>:
                                        <Fragment>
                                            <div className="clearfix"></div>
                                            <div className="col-md-12 col-sm-12 col-xs-12 createmenu-link-group">
                                                <p className="input-group col-md-9 col-md-offset-3 col-sm-12 col-xs-12 text-left">Upload Meal data to create the menu. Download&nbsp;<a
                                                href= { this.props.type===MealTypes.BREAKFAST? "https://s3.amazonaws.com/mealmanage-prod/SampleFiles/BreakfastMenu.xlsx": "https://s3.amazonaws.com/mealmanage-prod/SampleFiles/MealMenu.xlsx"}
                                                    download>Sample
                                                    file</a>
                                                </p>
                                            </div>
                                            <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                                <label className="control-label"> Import Meal Data </label>
                                            </div>
                                            <div className="uploadFileInfo col-md-12 col-sm-12 col-xs-12 createmenu-file-group">
                                                <div className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12">
                                                    <input type="file" className="form-control"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        style={{opacity: '1', zIndex: '0'}}
                                                        id="mealFile" aria-describedby="basic-addon21" 
                                                        onChange={(e)=>{
                                                            let validExts = new Array(".xlsx", ".xls");
                                                            let fileExt = e.target.files[0].name.split('.').pop();
                                                            const fileSize = e.target.files[0].size;
                                                            const fileMb = fileSize / 1024 ** 2;
                                                            
                                                            if (validExts.indexOf('.'+fileExt) < 0) {
                                                                _addNotificationError("Invalid file format. Please select valid file format (" +
                                                                    validExts.toString() + ")",this);
                                                                e.target.value='';
                                                            return false;
                                                            }else if(fileMb >= 2){
                                                                _addNotificationError("Please select a file less than 2MB.",this);
                                                                e.target.value='';
                                                                return false;
                                                            }
                                                            else return true;
                                                    }}
                                                    />
                                                    <button id="OpenUpload"
                                                        className="input-group-addon" onClick={() => {
                                                    $('#mealFile').click()
                                                }}><i
                                                    className="fa fa-upload"
                                                    aria-hidden="true"/>
                                                </button>
                                                </div>
                                            </div>
                                            <div className="col-md-8 col-md-offset-3 text-left">

                                            {
                                                ((this.props.mealType===MealTypes.SNACK) || (this.props.mealType===MealTypes.LUNCH) || (this.props.mealType===MealTypes.BREAKFAST) || (this.props.mealType===MealTypes.DINNER)) && isRegularLunchOrderType() ? 
                                                (<Fragment>
                                                    <div className="form-group">
                                                        <div className="checkbox">
                                                            <label>
                                                                <input type="checkbox" id="isDiscountApplyed"  checked={this.state.discount.isDiscountApplyed} 
                                                                onChange={(e)=>{
                                                                    const _discount=this.state.discount;
                                                                    _discount.isDiscountApplyed=e.target.checked?true:false;
                                                                    this.props.onDiscountSelectChange(e.target.checked);
                                                                }} /><span className="label-text">Apply monthly order discount</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.discount.isDiscountApplyed ?
                                                        <div className="form-group">
                                                            <label for="itemPriceDisForMonthlyOrder">Discount amount per meal</label>
                                                            <NumberBox type="text" className="form-control" maxLength="6" value={this.state.discount.itemPriceDisForMonthlyOrder} 
                                                            id="itemPriceDisForMonthlyOrder" name="itemPriceDisForMonthlyOrder" placeholder="0.00" 
                                                                onChange={(e)=>{
                                                                    this.props.onDiscountChanged(e.target.value);
                                                                }}   
                                                            noValidate/>
                                                        </div>:null
                                                    }                        
                                                </Fragment>):null

                                            }
                                            </div>
                                        </Fragment>
                                    }

                                    <div className="col-md-7 col-md-offset-3 text-center">
                                        <button type="submit" id="submit" className="btn btn-sm btn-primary"><i
                                            className="fa fa-arrow-circle-right"></i><span>Proceed</span></button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-12 col-xs-12 createmenu-panel">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">Menu Excel File
                                    Records</h3></div>
                                <div className="panel-body">
                                    <div id="file"></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

        );
    }

}

export default mealForm;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/mealForm.js